import type { LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import FctvaPanel from '../panel/FctvaPanel';
import MandatAnnulationReductionPanel from '../panel/InformationsRattachement/MandatAnnulationReductionPanel';
import InventairePanel from '../panel/InventairePanel';
import NumeroEmpruntPanel from '../panel/NumeroEmpruntPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import BaseProfilRattachement from './Base/BaseProfilRattachement';

class ProfilEcritureAnnulReducMandatExeCourantDepense extends BaseProfilRattachement {
	constructor(anneeExercice: number) {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.ANNUL_REDUC_MANDAT_EXE_COURANT;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ANNUL_REDUC;
		this.naturePiece = NATURE_PIECE.DEPENSE.ANNUL_REDUC;
		this.typePiece = TYPE_PIECE.DEPENSE.CORRECTIF;
		this.modeDeReglement = [MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE];
		this.defaultModeReglement = MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE;
		this.naturePieceOrigine = NATURE_PIECE_ORIGINE.MANDAT.MANDAT.CODE;
		this.exerRattachement = anneeExercice.toString();
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new FctvaPanel(),
			new MandatAnnulationReductionPanel(true),
			new InventairePanel(),
			new NumeroEmpruntPanel(),
			new PeriodeCouvertePanel(),
			new ProjetPanel(),
			new TravauxEnRegiePanel(),
			// TODO : add "Marche public" optional panel
			// TODO : add "Nomenclature achat" optional panel
		];
	}

	checkLigne(ligne: LigneMouvement): ErrorField[] {
		return [
			...super.checkLigne(ligne),
			...this.checkExerRattachementIdentique(ligne),
			...this.checkPieceOrigineRenseignee(ligne),
			...this.checkIdLigneOriginePesRenseigne(ligne),
		];
	}
}

export default ProfilEcritureAnnulReducMandatExeCourantDepense;
